const scriptSelector = '#com_reccomend'
const targetSelector = '.cs-reccomend'

const html = `
<h2 class="csr-title"><span>困ったり分からなくなった時におすすめ！</span></h2>
<div class="csr-list">
  <div class="swiper-container sliderCSR">
    <div class="swiper-wrapper">
      
      <div class="swiper-slide csr-item" data-csr-item="csr1"><a href="https://kintone.cybozu.co.jp/support/tel.html" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-01.png" srcset="../assets/images/module/csr-thumb-01@2x.png 2x" alt="カスタマーサポート"></div>
        <h3 class="title">メール・電話で相談なら<br>カスタマーサポート</h3>
        <p class="text">30日間の無料お試し中からサポートを利用することができます。kintoneの操作や使い方に困ったときには、電話又はメールでお問い合わせください。（cybozu.com共通管理権限が必要です）</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr2"><a href="https://kintone.cybozu.co.jp/consult/" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-02.png" srcset="../assets/images/module/csr-thumb-02@2x.png 2x" alt="導入相談カフェ"></div>
        <h3 class="title">じっくり対面相談なら<br>キントーン相談窓口</h3>
        <p class="text">kintone導入の進め方や、導入後の展開・活用について、オンライン、または対面でご相談を承ります。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr3"><a href="https://kintone.cybozu.co.jp/seminar/?keyword=%E3%81%AF%E3%81%98%E3%82%81%E3%81%A6%E3%81%AE%E6%96%B9%E5%90%91%E3%81%91" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-03.png" srcset="../assets/images/module/csr-thumb-03@2x.png 2x" alt="はじめての方向けセミナー"></div>
        <h3 class="title">基本を学ぶなら<br>はじめての方向けセミナー</h3>
        <p class="text">初心者向けから部門別の使い方まで様々なkintoneの活用方法を紹介するサイボウズ主催のセミナーを一年を通して開催中です。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr4"><a href="https://kintone.cybozu.co.jp/seminar/ondemand.html" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-04.png" srcset="../assets/images/module/csr-thumb-04@2x.png 2x" alt="動画で学ぼう"></div>
        <h3 class="title">自分のペースでじっくり<br>動画で学ぼう</h3>
        <p class="text">kintoneの基本的なアプリの使い方や操作方法を、実際の画面を使ってご紹介しています。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr5"><a href="https://kintone.cybozu.co.jp/support/menu/partner/" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-05.png" srcset="../assets/images/module/csr-thumb-05@2x.png 2x" alt="パートナーに相談"></div>
        <h3 class="title">業務改善の伴走者が必要なら<br>キントーン相談窓口</h3>
        <p class="text">パートナーとは、kintoneの導入前後のお客さまをサポートするサイボウズ公認の協力企業です。「導入をサポートしてほしい」「プロに開発を頼みたい」ならまずは相談してみましょう。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr6"><a href="https://kintone.cybozu.co.jp/consult/" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-06.png" srcset="../assets/images/module/csr-thumb-06@2x.png 2x" alt="導入相談窓口"></div>
        <h3 class="title">とりあえずなんでも<br>導入相談窓口</h3>
        <p class="text">kintone導入の進め方や、導入後の展開・活用について、オンライン、または対面でご相談を承ります。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr7"><a href="https://jp.cybozu.help/k/ja/index.html" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-07.png" srcset="../assets/images/module/csr-thumb-07@2x.png 2x" alt="kintone 公式ヘルプ"></div>
        <h3 class="title">キーワードで検索<br>公式ヘルプ</h3>
        <p class="text">kintone導入の進め方や、導入後の展開・活用について、オンライン、または対面でご相談を承ります。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr8"><a href="https://kincom.cybozu.co.jp/" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-08.png" srcset="../assets/images/module/csr-thumb-08@2x.png 2x" alt="ユーザーコミュニティ キンコミ"></div>
        <h3 class="title">ひとりで悩んでいるなら<br>ユーザーコミュニティ キンコミ</h3>
        <p class="text">ひとりで悩んでいるならユーザーコミュニティの「キンコミ」がオススメ。運用や活用ノウハウを他のユーザーとシェアしたり、お悩みなど相談できます。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr9"><a href="https://kintone.cybozu.co.jp/support/menu/" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-09.png" srcset="../assets/images/module/csr-thumb-09@2x.png 2x" alt="活用応援サポートメニュー"></div>
        <h3 class="title">活用応援<br>サポートメニュー一覧</h3>
        <p class="text">サポート活用上手はkintone活用上手！業務効率化やチームワーク向上を目指すみなさまを、導入前から導入後まで応援するサポートメニューを多数ご用意。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr10"><a href="https://kintone.cybozu.co.jp/material/#guidebook" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-10.png" srcset="../assets/images/module/csr-thumb-10@2x.png 2x" alt="便利に使おうガイドブック"></div>
        <h3 class="title">機能別の操作を資料で学べる<br>便利に使おうガイドブック</h3>
        <p class="text">kintoneの基本機能である「ルックアップ」「計算」「アクセス権」など、設定方法を丁寧に解説した資料です。社内勉強会の資料としてもおすすめです。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr11"><a href="https://cybozu.dev/ja/" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-11.png" srcset="../assets/images/module/csr-thumb-11@2x.png 2x" alt="cybozu developer network"></div>
        <h3 class="title">カスタマイズを知りたいなら<br>開発コミュニティサイト</h3>
        <p class="text">kintone APIドキュメントやTips、困ったときに情報交換できる開発者向けコミュニティなど、kintoneのカスタマイズの実践に欠かせない情報が集まるサイトです。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr12"><a href="https://page.cybozu.co.jp/-/kintone-devcamp-stepup" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-12.png" srcset="../assets/images/module/csr-thumb-12@2x.png 2x" alt="ステップで学ぶkintoneカスタマイズ勉強会"></div>
        <h3 class="title">カスタマイズを学びたいなら<br>kintoneカスタマイズ勉強会</h3>
        <p class="text">JavaScriptやREST APIなど、kintoneのカスタマイズを学びたい方向けの勉強会です。レベルに応じてステップが分かれており、自分のレベルにあった講座を選んで参加できます。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr13"><a href="https://kintone.cybozu.co.jp/seminar/?keyword=%E3%82%B9%E3%82%BF%E3%83%BC%E3%83%88%E3%82%AC%E3%82%A4%E3%83%89" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-13.png" srcset="../assets/images/module/csr-thumb-13@2x.png 2x" alt="スタートガイドセミナー"></div>
        <h3 class="title">浸透・定着を学ぶなら<br>スタートガイドセミナー</h3>
        <p class="text">kintoneを導入したばかりの方向けに、導入から社内への浸透・定着までに必要なことを4つのステップで学ぶことができるセミナーです。</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr14"><a href="https://www.youtube.com/channel/UCMFO4IyRhOvdvyuFNR0q8zw" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-14.png" srcset="../assets/images/module/csr-thumb-14@2x.png 2x" alt="動画で学ぼうkinTech（キンテク）"></div>
        <h3 class="title">動画で学ぼう<br>kinTech（キンテク）</h3>
        <p class="text">kintone に関するAPI更新情報や初心者向けのカスタマイズ講座など、最新の技術情報を「動画」でご紹介します！</p>
      </a></div>

      <div class="swiper-slide csr-item" data-csr-item="csr15"><a href="https://kintone-sol.cybozu.co.jp/integrate/search/" target="_blank">
        <div class="thumb"><img src="../assets/images/module/csr-thumb-15.png" srcset="../assets/images/module/csr-thumb-15@2x.png 2x" alt="200種類以上を公開中 拡張機能や連携サービスを探す"></div>
        <h3 class="title">200種類以上を公開中<br>拡張機能や連携サービスを探す</h3>
        <p class="text">「キントーン専用拡張機能サービス」「外部サービス連携」「業種業務アプリパッケージ」からお悩みややりたいことに合わせて、最適な方法をお選びいただけます。</p>
      </a></div>
      
    </div>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
</div>

`

document.addEventListener('DOMContentLoaded', () => {
  const targetElm = document.querySelector(targetSelector)
  targetElm.insertAdjacentHTML('beforeend', html)

  setItemClass(targetElm)

  if(window.matchMedia('(max-width: 768px)').matches){
    const obs = new IntersectionObserver((rcds) => {
      if(rcds.some(r => r.isIntersecting)){
        const swiper = setSwiperCSR()
      }
    }, {
      threshold: [0.05]
    })
    obs.observe(document.querySelector('.sliderCSR'))
  }
})

const setItemClass = (targetElm) => {
  if(targetElm.dataset.csrShow === void 0 || targetElm.dataset.csrShow.trim().length === 0){
    return
  }

  const shows = targetElm.dataset.csrShow.split(' ').reverse()
  Array.from(document.querySelectorAll('.csr-item')).forEach(item => {
    if(!shows.includes(item.dataset.csrItem)){
      item.parentElement.removeChild(item)
    }
  })
  for(let i = shows.length - 1; -1 < i; i--){
    const showItem = Array.from(document.querySelectorAll('.csr-item')).find(item => {
      return item.dataset.csrItem === shows[i]
    })

    document.querySelector('.csr-list .swiper-wrapper').appendChild(showItem)
  }

}

const setSwiperCSR = () => {
  return new Swiper('.sliderCSR', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides : true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}
